/**
 * AR content for the "Verdon" private excursion.
 *
 * Role: Arabic (MSA) translation of slugs/verdon.ts, typed `ExcursionPage`
 * for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR (place name).
 */
import type { ExcursionPage } from "../slug-excursions";
import verdon from "@/assets/images/excursions/destinations/verdon.webp";

const page: ExcursionPage = {
  slug: "verdon",
  hero: {
    title: "رحلة فِردون",
    subtitle: "مضائق فِردون والبحيرات الزرقاء: طبيعة مهيبة انطلاقًا من كان.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "احجز الآن",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "اطلب عرض سعر",
    image: verdon,
  },
  highlights: {
    title: "أبرز المعالم",
    items: [
      { text: "مضائق فِردون والمنحدرات الشاهقة" },
      { text: "بحيرات فيروزية ونقاط مشاهدة" },
      { text: "قرى بروفنسية كخيار إضافي" },
      { text: "طرق بانورامية وجسور أيقونية" },
    ],
  },
  itinerary: {
    title: "برنامج مقترح",
    steps: [
      {
        title: "الطريق نحو فِردون",
        description: "وقفات بانورامية.",
      },
      {
        title: "نقاط المشاهدة",
        description: "صور ووقت حر حسب الطقس.",
      },
      {
        title: "البحيرة (اختياري)",
        description: "سانت كروا / سان كاسيان حسب المسار.",
      },
      {
        title: "العودة",
        description: "راحة وأمان.",
      },
    ],
  },
  practical: {
    title: "معلومات عملية",
    items: [
      { label: "المدة", value: "من 8 إلى 10 ساعات" },
      { label: "نصيحة", value: "احمل الماء وواقي الشمس" },
      { label: "الانطلاق", value: "كان" },
      { label: "الأحذية", value: "احرص على أحذية مناسبة" },
    ],
  },
};

export default page;
